function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import omit from 'object.omit';
import { isDef, browser } from '@cloud-sn/v-utils';
import { buildComponentName } from '../utils';
import Icon from '../icon';
import InnerDrawer from './innerDrawer';
import Mixin from './mixin';
export default {
  name: buildComponentName('Drawer'),
  provide: function provide() {
    return {
      drawerRoot: this
    };
  },
  inject: {
    drawerRoot: {
      default: false
    }
  },
  mixins: [Mixin],
  props: {
    prefixCls: {
      type: String,
      default: 'ux-drawer'
    },
    width: {
      type: [String, Number],
      default: 256
    },
    height: {
      type: [String, Number],
      default: 256
    },
    bodyClass: {
      type: [String, Object, Array],
      default: ''
    },
    bodyStyle: {
      type: Object,
      default: null
    },
    placement: {
      type: String,
      default: 'right',
      validator: function validator(val) {
        return ['top', 'left', 'right', 'bottom'].indexOf(val) > -1;
      }
    },
    zIndex: {
      type: [Number, String],
      default: ''
    },
    destroyOnClose: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    closable: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      chidrenIsVisible: false,
      destroyDrawer: false
    };
  },
  computed: {
    classes: function classes() {
      var showMask = this.showMask;
      return {
        'no-mask': !showMask
      };
    },
    isChildren: function isChildren() {
      return !!this.drawerRoot;
    },
    wrapperStyle: function wrapperStyle() {
      var zIndex = this.zIndex,
          placement = this.placement,
          chidrenIsVisible = this.chidrenIsVisible;
      var style = isDef(zIndex) && zIndex !== '' ? {
        zIndex: zIndex
      } : {};

      if (chidrenIsVisible) {
        var transform = 'translateX(-180px)';

        switch (placement) {
          case 'top':
            transform = 'translateY(180px)';
            break;

          case 'left':
            transform = 'translateX(-180px)';
            break;

          case 'bottom':
            transform = 'translateY(-180px)';
            break;

          default:
            break;
        }

        style.transform = transform;
      }

      return style;
    },
    wrapperBodyStyle: function wrapperBodyStyle() {
      var placement = this.placement,
          innerVisible = this.innerVisible,
          destroyOnClose = this.destroyOnClose;
      var style = !innerVisible && destroyOnClose ? {
        opacity: 0,
        transition: 'opacity 300ms'
      } : null;

      switch (placement) {
        case 'left':
        case 'right':
          style = _objectSpread({}, style, {
            overflow: 'auto',
            height: '100%'
          });
          break;

        default:
          break;
      }

      return style;
    },
    bindProps: function bindProps() {
      var $props = this.$props,
          classes = this.classes,
          wrapperClass = this.wrapperClass,
          wrapperStyle = this.wrapperStyle,
          placement = this.placement,
          width = this.width,
          height = this.height;

      var props = _objectSpread({}, omit($props, ['width', 'height']));

      if (placement === 'left' || placement === 'right') {
        props.width = width;
      } else {
        props.height = height;
      }

      return _objectSpread({}, props, {
        wrapperClass: [classes, wrapperClass],
        wrapperStyle: wrapperStyle
      });
    },
    bindListeners: function bindListeners() {
      var $listeners = this.$listeners,
          onMaskClick = this.onMaskClick,
          onContentTransitionEnd = this.onContentTransitionEnd;
      return _objectSpread({}, $listeners, {
        'mask-click': onMaskClick,
        'content-transitionend': onContentTransitionEnd
      });
    }
  },
  watch: {
    visible: function visible(nVal) {
      this.setInnerVisible(nVal, false);
    }
  },
  mounted: function mounted() {
    var setInnerVisible = this.setInnerVisible,
        visible = this.visible;
    setInnerVisible(visible, false);
  },
  methods: {
    setChildrenIsVisible: function setChildrenIsVisible(flag) {
      this.chidrenIsVisible = flag;
    },
    updateParentDrawer: function updateParentDrawer() {
      var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var isChildren = this.isChildren,
          drawerRoot = this.drawerRoot;

      if (isChildren) {
        drawerRoot.setChildrenIsVisible(flag);
      }
    },
    setInnerVisible: function setInnerVisible(visible) {
      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var innerVisible = this.innerVisible,
          updateParentDrawer = this.updateParentDrawer;
      this.innerVisible = visible;

      if (innerVisible !== visible) {
        updateParentDrawer(visible);

        if (trigger) {
          this.$emit('input', visible);
        }
      }
    },
    close: function close(e) {
      this.$emit('close', e);
      this.setInnerVisible(false);
    },
    onMaskClick: function onMaskClick(e) {
      this.close(e);
    },
    onContentTransitionEnd: function onContentTransitionEnd(op, e) {
      var destroyOnClose = this.destroyOnClose;

      if (op === 'close' && destroyOnClose) {
        this.destroyDrawer = true;
      } // http://opensource.cnsuning.com/uxcool/lerna-uxcool/issues/305


      this.$emit('transitionend', op, e);
    },
    onClose: function onClose(e) {
      this.close(e);
    },
    renderChildren: function renderChildren() {
      var h = this.$createElement;
      var _this$$slots = this.$slots,
          slotDefault = _this$$slots.default,
          slotTitle = _this$$slots.title,
          prefixCls = this.prefixCls,
          wrapperBodyStyle = this.wrapperBodyStyle,
          bodyClass = this.bodyClass,
          bodyStyle = this.bodyStyle,
          innerVisible = this.innerVisible,
          destroyDrawer = this.destroyDrawer,
          title = this.title,
          closable = this.closable,
          onClose = this.onClose;

      if (destroyDrawer && !innerVisible) {
        return null;
      }

      this.destroyDrawer = false;
      var titleNode = slotTitle || title;
      return h("div", {
        "class": "".concat(prefixCls, "-wrapper-body"),
        "style": wrapperBodyStyle
      }, [titleNode ? h("div", {
        "class": "".concat(prefixCls, "-header")
      }, [h("div", {
        "class": "".concat(prefixCls, "-title")
      }, [titleNode])]) : null, closable ? h("button", {
        "class": "".concat(prefixCls, "-close"),
        "attrs": {
          "aria-label": "Close"
        },
        "on": {
          "click": onClose
        }
      }, [h("span", {
        "class": "".concat(prefixCls, "-close-x")
      }, [h(Icon, {
        "attrs": {
          "type": "close"
        }
      })])]) : null, h("div", {
        "class": ["".concat(prefixCls, "-body"), bodyClass],
        "style": bodyStyle
      }, [slotDefault])]);
    }
  },
  render: function render() {
    var h = arguments[0];
    var bindProps = this.bindProps,
        bindListeners = this.bindListeners,
        renderChildren = this.renderChildren;
    return h(InnerDrawer, {
      "props": _objectSpread({}, bindProps),
      "on": _objectSpread({}, bindListeners)
    }, [renderChildren()]);
  }
};